import { useMutation, useQueryClient } from '@tanstack/react-query';
import { aiAgentApis } from '../../../../../../../shared/apis/ai-agent/apis';
import { AxiosError } from 'axios';
import { AxiosCommonError } from '../../../../../../../shared/types';
import { handleError } from '../../../../../../ui/err/handleError';
import { showSuccessNotification } from '../../../../../../ui/notification';
import { queries } from '../../../../../../../shared/queries';

export default function usePutFileApplied() {
  const queryClient = useQueryClient();
  return useMutation(aiAgentApis.manual.putFileApplied, {
    onSuccess: () => {
      showSuccessNotification('적용되었습니다.');
      queryClient.invalidateQueries({ queryKey: queries.aiAgent.aiAgentManuals._def });
    },
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}
